import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"
import {
  ErrorBoundary,
  Loading,
  ModalContainer,
  ObjectMap,
} from "web/components"
import { BrowserRouter as Router } from "react-router-dom"
import { NavigationProvider } from "web/contexts"
import { AppProviders, LibraryProviders } from "web/Providers"

export default class ObjectMapController extends Controller {
  static values = {
    viewGroup: Object,
    viewId: Number,
    subjectType: String,
    parentSubjectType: String,
    parentSubjectId: Number,
    topic: Object,
    modalTitle: String,
    itemClickBaseUrls: Object,
    subjectBaseUrl: String,
    fetchUrl: String,
    enableSelection: { default: false, type: Boolean },
  }

  initialize() {
    global.React = React
  }

  onItemClick(subjectType, id) {
    const baseUrl = this.itemClickBaseUrlsValue[subjectType]
    if (!baseUrl) return

    window.Turbo.visit(`${baseUrl}/${id}`)
  }

  disconnect() {
    // Turbo transplants this data-turbo-permanent element during page renders,
    // which briefly disconnects it; only unmount when it truly left the page.
    requestAnimationFrame(() => {
      if (!this.element.isConnected) {
        unmountComponentAtNode(this.element)
      }
    })
  }

  connect() {
    const parentSubjectType = this.hasParentSubjectTypeValue
      ? this.parentSubjectTypeValue
      : undefined

    const parentSubjectId = this.hasParentSubjectIdValue
      ? this.parentSubjectIdValue
      : undefined

    const topic = this.hasTopicValue ? this.topicValue : undefined

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <NavigationProvider
                viewGroup={this.viewGroupValue}
                viewId={this.viewIdValue}
                subjectType={this.subjectTypeValue}
              >
                <ErrorBoundary>
                  <ObjectMap
                    subjectType={this.subjectTypeValue}
                    parentSubjectType={parentSubjectType}
                    parentSubjectId={parentSubjectId}
                    topic={topic}
                    modalTitle={this.modalTitleValue}
                    fetchURL={this.fetchUrlValue}
                    enableSelection={this.enableSelectionValue}
                    onItemClick={
                      this.hasItemClickBaseUrlsValue
                        ? this.onItemClick.bind(this)
                        : undefined
                    }
                    subjectBaseUrl={
                      this.hasSubjectBaseUrlValue
                        ? this.subjectBaseUrlValue
                        : undefined
                    }
                  />
                </ErrorBoundary>
              </NavigationProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
